import { ChevronRightIcon } from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";


export default function InfoBanner() {
    return (
        
        <section className="info-banner">
             <div className="business-survival-quiz-bannner bg-text-color text-center flex justify-center items-center py-3 lg:px-0 px-3">
                <p className="text-white text-base lg:text-lg lg:flex items-center justify-center">The future belongs to the bold. In five years, will your business be ahead or left behind? 
                  <Link to={"/quiz/business-survival/intro"}> <span className="text-light-pink-6 font-semibold flex items-center justify-center ml-2 underline underline-offset-4">
                     Let's find out 
                     <ChevronRightIcon className="size-7" />
                     </span>
                     </Link></p>
             </div>
        </section>

    ) 
}